import React from 'react';

export const RAG_THINKING_LABEL = 'Thinking';
export const RAG_FINAL_RESPONSE_DRAFTING_LABEL = 'I’m drafting the final response now';

export const RagThinkingIndicator = ({ label = RAG_THINKING_LABEL }) => (
    <span className="library-rag-thinking-indicator" aria-live="polite">
        <span className="library-rag-thinking-label">{label}</span>
        <span className="library-rag-thinking-dots" aria-hidden="true">
            <span />
            <span />
            <span />
        </span>
    </span>
);

export const RagSidebarMark = ({ className = '' }) => (
    <svg className={className} width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" focusable="false">
        <path d="M5.1 4.2C4.15 4.2 3.38 4.97 3.38 5.92V16.08C3.38 17.03 4.15 17.8 5.1 17.8H16.9C17.85 17.8 18.62 17.03 18.62 16.08V5.92C18.62 4.97 17.85 4.2 16.9 4.2H5.1Z" stroke="currentColor" strokeWidth="1.45" />
        <path d="M8.35 4.55V17.45" stroke="currentColor" strokeWidth="1.45" strokeLinecap="round" />
        <path d="M11.15 8.15H15.55" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
        <path d="M11.15 11H14.7" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
        <path d="M11.15 13.85H15.05" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
    </svg>
);
